import { useEffect, useState } from "react";

import type { IPagination } from "./types";
import RightArrowIcon from "../../../assets/icons/RightArrowIcon";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import { computeVisiblePages } from "./computeVisiblePages";
import { Nav, PageButton, Ellipsis } from "./style";

export const Pagination = ({
  pageCount,
  changePage,
  pageSelected,
}: IPagination) => {
  const total = pageCount || 1;
  const [current, setCurrent] = useState(pageSelected ?? 0);

  useEffect(() => {
    if (pageSelected !== undefined && pageSelected !== current) {
      setCurrent(pageSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSelected]);

  function handleChange(idx: number) {
    if (idx < 0 || idx >= total) return;
    setCurrent(idx);
    if (changePage) {
      (changePage as (page: number) => void)(idx);
    }
  }

  const pages = computeVisiblePages({
    current,
    total,
    marginPages: 1,
    range: 3,
  });

  return (
    <Nav aria-label="Paginação">
      <PageButton
        type="button"
        aria-label="Página anterior"
        disabled={current === 0}
        onClick={() => handleChange(current - 1)}
      >
        <LeftArrowIcon />
      </PageButton>
      {pages.map((p, i) =>
        p === "..." ? (
          <Ellipsis key={`ellipsis-${i}`} aria-hidden="true">
            …
          </Ellipsis>
        ) : (
          <PageButton
            type="button"
            key={p}
            $active={p === current}
            aria-label={`Página ${p + 1}`}
            onClick={() => handleChange(p)}
            {...(p === current && { "aria-current": "page" as const })}
          >
            {p + 1}
          </PageButton>
        ),
      )}
      <PageButton
        type="button"
        aria-label="Próxima página"
        disabled={current === total - 1}
        onClick={() => handleChange(current + 1)}
      >
        <RightArrowIcon />
      </PageButton>
    </Nav>
  );
};
